import { render } from "./ThreejsObjComponent.vue?vue&type=template&id=0e7bd63f&scoped=true"
import script from "./ThreejsObjComponent.vue?vue&type=script&lang=js"
export * from "./ThreejsObjComponent.vue?vue&type=script&lang=js"

import "./ThreejsObjComponent.vue?vue&type=style&index=0&id=0e7bd63f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7bd63f"]])

export default __exports__